/**
 * VCloud Information Helpers
 */

/**
 * Parse VM configuration from name (e.g., "v2g-standard-8-32" -> 8 vCores, 32 GB RAM)
 */
export const parseVMConfig = (name: string) => {
    if (!name) return { cores: 0, ram: 0 }
    const match = name.match(/(\d+)-(\d+)$/)
    if (match) {
        return {
            cores: parseInt(match[1]),
            ram: parseInt(match[2]),
        }
    }
    return { cores: 0, ram: 0 }
}

/**
 * Check if config is storage type
 */
export const isStorageType = (type?: string, name?: string): boolean => {
    const t = type?.toLowerCase() || ''
    const n = name?.toLowerCase() || ''
    return (
        t.includes('storage') ||
        t.includes('disk') ||
        t.includes('ssd') ||
        t.includes('hdd') ||
        n.includes('storage') ||
        n.includes('disk') ||
        n.includes('ssd') ||
        n.includes('hdd')
    )
}

/**
 * Check if config is Public IP type
 */
export const isPublicIPType = (type?: string, name?: string): boolean => {
    const t = type?.toLowerCase() || ''
    const n = name?.toLowerCase() || ''
    // Match public IP but not floating IP
    if (t.includes('floating') || n.includes('floating')) return false
    return (
        (t.includes('public') && t.includes('ip')) ||
        (n.includes('public') && n.includes('ip')) ||
        t === 'public-ip' ||
        t === 'publicip' ||
        n === 'public-ip' ||
        n === 'publicip'
    )
}

/**
 * Check if config is Floating IP type
 */
export const isFloatingIPType = (type?: string, name?: string): boolean => {
    const t = type?.toLowerCase() || ''
    const n = name?.toLowerCase() || ''
    return t.includes('floating') || n.includes('floating')
}

/**
 * Check if config is Bandwidth type
 */
export const isBandwidthType = (type?: string, name?: string): boolean => {
    const t = type?.toLowerCase() || ''
    const n = name?.toLowerCase() || ''
    return (
        t.includes('bandwidth') ||
        t.includes('bw') ||
        n.includes('bandwidth') ||
        n.includes('bw')
    )
}

/**
 * Get service type from item
 */
export const getServiceType = (
    item: any
): 'vm_instance' | 'vm_lb' | 'other_service' => {
    const type = item.type?.toLowerCase() || ''
    const name = item.name?.toLowerCase() || ''
    if (type === 'vm-instance' || name.includes('instance'))
        return 'vm_instance'
    if (
        type === 'vm-lb' ||
        name.includes('lb') ||
        name.includes('load') ||
        name.includes('balancer')
    )
        return 'vm_lb'
    return 'other_service'
}
